import { render } from "./DividerComponent.vue?vue&type=template&id=cbfdf5a0"
import script from "./DividerComponent.vue?vue&type=script&lang=js"
export * from "./DividerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__